/**
 * How a Finance receipt should be RENDERED, decided from the fetched blob's
 * MIME type (#440). An image previews as itself; a PDF invoice previews as a
 * page render plus the full document. Anything else falls back to the image
 * path (the browser shows its broken-image state, as before #440).
 */
export const isPdfContentType = (type) => /^application\/(x-)?pdf\b/i.test(String(type || '').trim());

export const receiptKind = (type) => {
    if (!type) return 'unknown';
    if (isPdfContentType(type)) return 'pdf';
    if (/^image\//i.test(String(type).trim())) return 'image';
    return 'other';
};
